import { render } from "./StudentConsequencesLadderTable.vue?vue&type=template&id=0bc694dc"
import script from "./StudentConsequencesLadderTable.vue?vue&type=script&lang=js"
export * from "./StudentConsequencesLadderTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__